"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelPurchaseOrderServiceReducer = exports.updatePurchaseOrderServiceReducer = exports.createPurchaseOrderServiceReducer = exports.fetchPendingPurchaseOrderServiceReducer = exports.fetchLastSuccessPurchaseOrderServiceReducer = exports.fetchPurchaseOrderServiceReducer = exports.cancelPurchaseOrderServiceSlice = exports.updatePurchaseOrderServiceSlice = exports.createPurchaseOrderServiceSlice = exports.fetchPendingPurchaseOrderServiceSlice = exports.fetchLastSuccessPurchaseOrderServiceSlice = exports.fetchPurchaseOrderServiceSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const purchaseOrderServiceAction_1 = require("./purchaseOrderServiceAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
const cancelInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.fetchPurchaseOrderServiceSlice = (0, toolkit_1.createSlice)({
    name: "subscriptionPurchaseOrderService/fetch",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(purchaseOrderServiceAction_1.fetch.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(purchaseOrderServiceAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(purchaseOrderServiceAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchLastSuccessPurchaseOrderServiceSlice = (0, toolkit_1.createSlice)({
    name: "subscriptionPurchaseOrderService/fetchLastSuccess",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(purchaseOrderServiceAction_1.fetchLastSuccess.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(purchaseOrderServiceAction_1.fetchLastSuccess.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(purchaseOrderServiceAction_1.fetchLastSuccess.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchPendingPurchaseOrderServiceSlice = (0, toolkit_1.createSlice)({
    name: "subscriptionPurchaseOrderService/fetchPending",
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(purchaseOrderServiceAction_1.fetchPending.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(purchaseOrderServiceAction_1.fetchPending.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(purchaseOrderServiceAction_1.fetchPending.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.createPurchaseOrderServiceSlice = (0, toolkit_1.createSlice)({
    name: "subscriptionPurchaseOrderService/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(purchaseOrderServiceAction_1.create.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(purchaseOrderServiceAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(purchaseOrderServiceAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.updatePurchaseOrderServiceSlice = (0, toolkit_1.createSlice)({
    name: "subscriptionPurchaseOrderService/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(purchaseOrderServiceAction_1.update.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(purchaseOrderServiceAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(purchaseOrderServiceAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.cancelPurchaseOrderServiceSlice = (0, toolkit_1.createSlice)({
    name: "subscriptionPurchaseOrderService/cancel",
    initialState: cancelInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(purchaseOrderServiceAction_1.cancel.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(purchaseOrderServiceAction_1.cancel.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(purchaseOrderServiceAction_1.cancel.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    }
});
exports.fetchPurchaseOrderServiceReducer = exports.fetchPurchaseOrderServiceSlice.reducer;
exports.fetchLastSuccessPurchaseOrderServiceReducer = exports.fetchLastSuccessPurchaseOrderServiceSlice.reducer;
exports.fetchPendingPurchaseOrderServiceReducer = exports.fetchPendingPurchaseOrderServiceSlice.reducer;
exports.createPurchaseOrderServiceReducer = exports.createPurchaseOrderServiceSlice.reducer;
exports.updatePurchaseOrderServiceReducer = exports.updatePurchaseOrderServiceSlice.reducer;
exports.cancelPurchaseOrderServiceReducer = exports.cancelPurchaseOrderServiceSlice.reducer;
